<template lang="pug">
.error-message(v-if="message")
  | {{ message }}
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.error-message {
  color: #c00;
  background-color: #ffc;
  margin: .5em 0;
  padding: .5em;
  font-size: 13/16rem;
  border-radius: .3em;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorMessage.vue